module.exports = __webpack_public_path__ + "static/media/Frame.caa17517.svg";